import Vue from "vue";
import { checkResponse } from "@/helpers/store";
import { nameFirme, countFirme, kindName, payName } from "@/helpers/reference";

const state = {
  packList: {
    data: [],
    rows: 0
  },
  infoPay: {
    result: ""
  },
  packVerification: null,
  returnPack: null,
  holdPack: null,
  postingPrepare: null,
  postingComplete: null,
  postingAllPrepare: null,
  packSelected: [],
  countbands: {
    data: [],
    countband: 0,
    sband: 0,
    countpay: 0,
    sumpay: 0,
    rows: 0
  },
  oneCountband: {
    data: [],
    sband: 0,
    countband: 0,
    spay: 0,
    countpay: 0,
    fullcount: 0,
    fullspay: 0,
    rows: 0
  },
  countbandsEdit: {
    rows: 0,
    nband: "",
    nob: ""
  },
  countbandsDelete: {
    rows: 0,
    nband: "",
    nob: ""
  },
  oneCountbandPaymentDelete: {
    message: "",
    type: ""
  },
  countbandPayment: {
    title: "",
    nband: "",
    amount: "",
    nop: ""
  },
  oneCountbandPayment: {
    data: [],
    rows: 0
  }
};

const mutations = {
  setPackList: (state, payload) => (state.packList = payload),
  clearPackList: state => (state.packList = { data: [], rows: 0 }),
  setInfoPay: (state, payload) => (state.infoPay = payload),
  clearInfoPay: state => (state.infoPay = { result: "" }),
  setPackVerification: (state, payload) => (state.packVerification = payload),
  clearPackVerification: state => (state.packVerification = null),
  setReturnPack: (state, payload) => (state.returnPack = payload),
  clearReturnPack: state => (state.returnPack = null),
  setHoldPack: (state, payload) => (state.holdPack = payload),
  clearHoldPack: state => (state.holdPack = null),
  setPostingPrepare: (state, payload) => (state.postingPrepare = payload),
  clearPostingPrepare: state => (state.postingPrepare = null),
  setPostingComplete: (state, payload) => (state.postingComplete = payload),
  clearPostingComplete: state => (state.postingComplete = null),
  setPostingAllPrepare: (state, payload) => (state.postingAllPrepare = payload),
  clearPostingAllPrepare: state => (state.postingAllPrepare = null),

  setPackSelected: (state, payload) => state.packSelected.push(payload),
  clearPackSelected: state => (state.packSelected = []),
  setCountbands: (state, payload) => (state.countbands = payload),
  clearCountbands: state =>
    (state.countbands = {
      data: [],
      countband: 0,
      sband: 0,
      countpay: 0,
      sumpay: 0,
      rows: 0
    }),
  setOneCountband: (state, payload) => (state.oneCountband = payload),
  clearOneCountband: state =>
    (state.oneCountband = {
      data: [],
      sband: 0,
      spay: 0,
      countband: 0,
      countpay: 0,
      fullcount: 0,
      fullspay: 0,
      rows: 0
    }),
  setCountbandsEdit: (state, payload) => (state.countbandsEdit = payload),
  clearCountbandsEdit: state =>
    (state.countbandsEdit = { rows: 0, nband: "", nob: "" }),
  setCountbandsDelete: (state, payload) => (state.countbandsDelete = payload),
  clearCountbandsDelete: state =>
    (state.countbandsDelete = { rows: 0, nband: "", nob: "" }),
  setOneCountbandPaymentDelete: (state, payload) =>
    (state.oneCountbandPaymentDelete = payload),
  clearOneCountbandPaymentDelete: state =>
    (state.oneCountbandPaymentDelete = { message: "", type: "" }),
  setCountbandPayment: (state, payload) => (state.countbandPayment = payload),
  clearCountbandPayment: state =>
    (state.countbandPayment = { title: "", nband: "", amount: "", nop: "" }),
  setOneCountbandPayment: (state, payload) =>
    (state.oneCountbandPayment = payload),
  clearOneCountbandPayment: state =>
    (state.oneCountbandPayment = { data: [], rows: 0 })
};

const actions = {
  async getPackList({ commit, rootState }, { typeform }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbrpack",
            funcname: "wbRunSelect",
            typeform: `${typeform}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPackList", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getInfoPay({ commit, rootState }, { npack }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbrpack",
            funcname: "wbRunInfo",
            npack: `${npack}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setInfoPay", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getPackVerification({ commit, rootState }, { npack }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbraznoska",
            funcname: "wbpackverification",
            npack: `${npack}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPackVerification", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async callReturnPack(
    { commit, rootState },
    { npack, datebeginfact, codereason }
  ) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbraznoska",
            funcname: "backpack",
            npack: `${npack}`,
            datebeginfact: `${datebeginfact}`,
            codereason: `${codereason}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setReturnPack", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async callHoldPack({ commit, rootState }, { npack, datebeginfact }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbraznoska",
            funcname: "holdpack",
            npack: `${npack}`,
            datebeginfact: `${datebeginfact}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setHoldPack", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async callPostingPrepare({ commit, rootState }, { npack, datebeginfact }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbraznoska",
            funcname: "wbraznoskaprepare",
            npack: `${npack}`,
            datebeginfact: `${datebeginfact}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPostingPrepare", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async callPostingComplete({ commit, rootState }, { npack }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbraznoska",
            funcname: "wbraznoska", //"wbraznoska", "wbraznoskatest" - тестовый
            npack: `${npack}`
            // flag: "2" // ### тестовый: 1 - "success", 2 - "warning", 3 - "error"
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPostingComplete", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async callPostingAllPrepare({ commit, state, rootState }) {
    try {
      commit("setFullPageLoading", true);

      const packList = [
        ...state.packList.data.map(item => {
          const { npack, datebeginfact } = item;
          return { npack, datebeginfact };
        })
      ];

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbraznoska",
            funcname: "wbfullraznoskaprepare",
            packlist: JSON.stringify(packList)
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setPostingAllPrepare", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getCountbands({ commit, rootState }, { npack }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbmassvvod",
            funcname: "wbRunSelectBand",
            npack: `${npack}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setCountbands", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getOneCountband({ commit, rootState }, { npack, nband }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbmassvvod",
            funcname: "wbRunSelectGrid",
            npack: `${npack}`,
            nband: `${nband}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setOneCountband", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async callCountbandsInsert(
    { commit, rootState },
    { npack, number, quantity, totalSum }
  ) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbmassvvod",
            funcname: "runInsertBand",
            npack: `${npack}`,
            nband: `${number}`,
            countpay: `${quantity}`,
            summband: `${totalSum}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setCountbandsEdit", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async callCountbandsEdit(
    { commit, rootState },
    { nob, number, quantity, totalSum }
  ) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbmassvvod",
            funcname: "runEditBand",
            nob: `${nob}`,
            nband: `${number}`,
            countpay: `${quantity}`,
            summband: `${totalSum}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setCountbandsEdit", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async callCountbandsDelete({ commit, rootState }, { nob }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbmassvvod",
            funcname: "runDelBand",
            nob: `${nob}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setCountbandsDelete", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async countbandPaymentOneDelete({ commit, rootState }, { nop }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbmassvvod",
            funcname: "DelOnePay",
            nop: `${nop}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setOneCountbandPaymentDelete", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async countbandPaymentAllDelete({ commit, rootState }, { npack, nband }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbmassvvod",
            funcname: "DelAllPay",
            npack: `${npack}`,
            nband: `${nband}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setOneCountbandPaymentDelete", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  },
  async getOneCountbandPayment({ commit, rootState }, { nop }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.wbmassvvod",
            funcname: "wbRunSelect",
            nop: `${nop}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setOneCountbandPayment", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  }
};

const getters = {
  packList: (state, rootState) => {
    let items = [];
    state.packList.data.forEach(item => {
      item["kindname"] = kindName(rootState.params.gkindpay.data, item.kindpay);
      item["namefirme"] = nameFirme(
        rootState.params.gfirme.data,
        item.codefirme
      );
      item["rcount"] = countFirme(rootState.params.gfirme.data, item.codefirme);
      items.push(item);
    });

    return items;
  },
  infoPay: state => state.infoPay.result,
  packVerification: state => state.packVerification,
  returnPack: state => state.returnPack,
  holdPack: state => state.holdPack,
  postingPrepare: state => state.postingPrepare,
  postingComplete: state => state.postingComplete,
  postingAllPrepare: state => state.postingAllPrepare,
  packSelected: (state, rootState) => {
    let items = [];
    state.packSelected.forEach(item => {
      item["namefirme"] = nameFirme(
        rootState.params.gfirme.data,
        item.codefirme
      );
      items.push(item);
    });

    return items;
  },
  countbands: state => state.countbands.data,
  countbandsTotalSum: state => {
    return {
      countband: state.countbands.countband,
      sband: state.countbands.sband,
      countpay: state.countbands.countpay,
      sumpay: state.countbands.sumpay
    };
  },
  oneCountband: (state, rootState) => {
    let items = [];
    state.oneCountband.data.forEach(item => {
      item["nameplat"] = payName(rootState.params.codepay.data, item.codeplat);
      items.push(item);
    });

    return items;
  },
  oneCountbandTotalSum: state => {
    return {
      sband: state.oneCountband.sband,
      countband: state.oneCountband.countband,
      spay: state.oneCountband.spay,
      countpay: state.oneCountband.countpay,
      fullcount: state.oneCountband.fullcount,
      fullspay: state.oneCountband.fullspay
    };
  },
  countbandsEdit: state => state.countbandsEdit,
  countbandsDelete: state => state.countbandsDelete,
  oneCountbandPaymentDelete: state => state.oneCountbandPaymentDelete,
  oneCountbandPayment: state => state.oneCountbandPayment,
  isCountbandPayment: state => !!state.countbandPayment.title,
  countbandPaymentTitle: state => state.countbandPayment.title,
  countbandPaymentAmount: state => state.countbandPayment.amount,
  countbandPaymentNop: state => state.countbandPayment.nop
};

export default { state, mutations, actions, getters };
